module.exports = __webpack_public_path__ + "static/media/add-circle.67298337.svg";